export * from './channel';
export * from './create-emotion-cache';
export * from './event';
export * from './extract-emoji-icon';
export * from './string2color';
export * from './toast';
export * from './unflatten-object';

// 是否为编辑页
export function isWorkspaceDetail(path) {
  const parts = path.split("/").filter(Boolean);
  return (
    parts[0] === "workspace" &&
    parts.length === 3 &&
    parts[2].length > 15 &&
    parts[1]
  );
}
